export default __webpack_public_path__ + "static/media/weprojectfull.71e1b068.svg";